<template>
  <header class="header">
    <div class="logo">
      Hello {{ authStoreData?.userData?.name }}
    </div>
    <nav class="nav">
      <ul>
        <li><router-link to="/">Home</router-link></li>
        <li><router-link to="/services">Services</router-link></li>
        <li><router-link to="/contact-us">Contact</router-link></li>
        <li v-if="authStoreData?.isAuthenticated">
          <button class="logout-btn" @click="logout">
            <i class="fas fa-sign-out-alt"></i> Logout
          </button>
        </li>
      </ul>
    </nav>
  </header>

  <!-- Main Content -->
  <div class="main-content">
    <router-view></router-view>
  </div>

  <!-- Footer -->
  <footer class="footer">
    <p>&copy; 2025 Secure Ethics. All rights reserved.</p>
  </footer>
</template>

<script lang="ts">
import { defineComponent, onMounted, computed } from 'vue';
import { useRouter } from 'vue-router';
import { useAuthStore } from '@/stores/authStore'

export default defineComponent({
  name: 'App',
  setup() {
    const router = useRouter();
    const authStore = useAuthStore();
    const authStoreData = computed(() => authStore);

    const logout = () => {
        authStore.logout()
        router.push('/login')
      }

    // Check if token exists in localStorage when the app mounts
    onMounted(() => {
      const token = localStorage.getItem('token');
      
      if (token) {
        // Token exists, validate it or navigate to the home page
        // Here, you could also validate the token further, for example by checking its expiry
        
        // Navigate to the home page if the token is valid
        router.push('/');  // or whatever your home route is
      } else {
        // No token, redirect to the login page
        router.push('/login');
      }
    });

    return {
      logout,
      authStoreData
    };
  },
});
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #0c0d0e;
}

.header {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 1000;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
  padding: 10px 20px;
}

.footer {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  z-index: 1000;
  box-shadow: 0 -2px 5px rgba(0, 0, 0, 0.1);
  padding: 10px 20px;
}


.logout-btn {
  padding: 5px 10px;
  background-color: #f44336; /* Red background for logout */
  color: white;
  border: none;
  border-radius: 3px;
  font-size: 14px;
  cursor: pointer;
  transition: background-color 0.3s ease, transform 0.2s ease;
}

.logout-btn:hover {
  background-color: #e03131; /* Slightly darker red on hover */
  transform: scale(1.05); /* Slight scale effect on hover */
}

.logout-btn:focus {
  outline: none;
  box-shadow: 0 0 5px rgba(244, 67, 54, 0.6); /* Add a red glow around the button on focus */
}

.logout-btn:active {
  background-color: #c62828; /* Darker red when button is pressed */
}


</style>
